import { Injectable } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class VfsMatStepperIntl extends MatStepperIntl {
  constructor(protected translateService: TranslateService) {
    super();
  }

  optionalLabel = this.translateService.instant('core.general.optional');
}
